import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import AutoOrderSetting from "../../components/organisms/AutoOrderSetting/AutoOrderSetting";
import PrintingPreference from "../../components/organisms/PrintingPreference/PrintingPreference";
import OperationalHours from "../../components/organisms/OperationalHours/OperationalHours";
import OperationalAddressSettings from "../../components/organisms/OperationalAddressSettings/OperationalAddressSettings";
import { FaAngleDown } from "react-icons/fa";
import HolidayDays from "../../components/organisms/HolidayDays/HolidayDays";
import { useLocation, useSearchParams } from "react-router-dom";
import { getUserPreference } from "../../api/api";
import {Spinner} from "../../components/atoms";


const Settings = () => {
  const [selected, setSelected] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasHockeyStore, setHasHockeyStore] = useState(false);
  const isAdmin =localStorage.getItem("roleId")=="1"
  const [searchParams] = useSearchParams();
  const handleSettingSwitch = (select) => {
    setSelected(select);
  };
  
  useEffect(async () => {
    
    if(searchParams.get('id')==3){
      handleSettingSwitch("holidayDays")
    }
    
    setIsLoading(true);
    var response = await getUserPreference();
    
    if (response) 
    {
        
      setHasHockeyStore(response.data.hasHockeyStore);
        
    }
    
    setIsLoading(false);
    
  }, []);
  
  const DisplaySpinner = () => {
    return (
      <div className="spinnerDiv">
        <Spinner color={"black"} loading={true} size={40} />
      </div>
    );
  };
  return (
    <>
      {!selected && (
        <div className="tabPanelCls h-100">
          <Toaster />
          <div
            className="dispatchTimer"
            style={{ position: "relative", marginTop: "20px" }}
          >
            <div
              style={{
                position: "fixed",
                width: "100%",
                background: "white",
                marginTop: "10px",
              }}
            >
              <div className="header">
                <h2>Settings</h2>
                <p>Adjust and optimize preferences.</p>
              </div>
            </div>
            {isLoading ? (<DisplaySpinner/>)
            : (<ul
              className="category-list d-sm-block "
              style={{ marginTop: "120px" }}
            >
              {isAdmin &&  <li
                style={{ cursor: "pointer" }}
              >
                <a className={'j'} style={{textDecoration:'none'}} href={'/Merchants'}>
                  <h3 style={{ color: "black" }}>Merchant Management</h3>
                </a>

                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>}
              {/* { <li
                style={{ cursor: "pointer" }}
              >
                <a className={'j'} style={{textDecoration:'none'}} href={'/thirdParty'}>
                  <h3 style={{ color: "black" }}>Third Party Integrations</h3>
                </a>

                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li> } */}

              <li
                onClick={() => handleSettingSwitch("autoOrder")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Auto Accept Orders</h3>

                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>
              {/* <li
                onClick={() => handleSettingSwitch("operationAddress")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Change Operational Address</h3>
                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li> */}
              <li
                onClick={() => handleSettingSwitch("holidayDays")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Change Holiday Days</h3>
                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>
              <li
                onClick={() => handleSettingSwitch("operationalHours")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Change Operational Hours</h3>
                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>
              <li
                onClick={() => handleSettingSwitch("printingPreference")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Label Printing Preferences</h3>
                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>
              {hasHockeyStore && <li
                onClick={() => window.open(process.env.REACT_APP_HOCKEY_PORTAL_URL, "_blank")}
                style={{ cursor: "pointer" }}
              >
                <h3 style={{ color: "black" }}>Switch to The Hockey Store</h3>
                <FaAngleDown
                  style={{ transform: "rotate(-90deg)" }}
                  fontSize={18}
                  color="black"
                />
              </li>}
            </ul>)}            
          </div>
        </div>
      )}

      {selected === "autoOrder" && (
        <AutoOrderSetting handleSettingSwitch={handleSettingSwitch} />
      )}
      {selected === "operationAddress" && (
        <OperationalAddressSettings  handleSettingSwitch={handleSettingSwitch}/>
      )}
      {selected === "holidayDays" && (
        <HolidayDays  handleSettingSwitch={handleSettingSwitch}/>
      )}
      {selected === "printingPreference" && (
        <PrintingPreference  handleSettingSwitch={handleSettingSwitch}/>
      )}
      {selected === "operationalHours" && (
        <OperationalHours  handleSettingSwitch={handleSettingSwitch}/>
      )}
    </>
  );
};

export default Settings;
